import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import AuthProvider from "./hooks/AuthProvider";
import PrivateRoute from "./router/router";
import { Route, Routes, BrowserRouter as Router } from "react-router-dom";
import { AdminAuthProvider } from "./hooks/AdminAuthProvider";
import MainApplication from "./components/MainApplication"; // here MainApplication refers to BaseTemplate in FCB project
import LoginForm from "./components/Login";
import MyWalletRedirect from "./components/MyWallet/MyWalletRedirect";
import ZohoCallback from "./components/Zoho/ZohoCallback";
import PaymentStatusPage from "./components/SubscriptionManagement/PaymentStatus";
import TenantOnboardingPage from "./components/Onboarding/TenantOnboardingPage";
import theme from "./theme";
import TenantSelection from "./components/TenantSelection";
import AdminMarketingDashboard from "./components/Admin/AdminMarketingDashboard";
import AdminLogin from "./components/AdminLogin";
import AdminRoute from "./router/adminRoute";
import AdminLoginGuard from "./router/adminGuard";
import { BrandingProvider } from "./hooks/brandingProvider";
import NotFound from "./components/NotFound";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AuthProvider>
          <AdminAuthProvider>
            <BrandingProvider>
              <Routes>
                <Route path="/login" element={<LoginForm />} />
                {/* Added admin login guard, this will only allow user to see the page, if he is not a tenant user */}
                <Route
                  path="/admin-login"
                  element={
                    <AdminLoginGuard>
                      <AdminLogin />
                    </AdminLoginGuard>
                  }
                />
                {/* Added admin Route auth protected wrapper, to only allow logged in internal admin user to view the admin dashboard page */}
                <Route
                  path="/admin-dashboard"
                  element={
                    <AdminRoute>
                      <AdminMarketingDashboard />
                    </AdminRoute>
                  }
                />
                <Route path="/signup" element={<TenantOnboardingPage />} />
                <Route path="/select-tenant" element={<TenantSelection />} />

                <Route element={<PrivateRoute />}>
                  <Route path="/" element={<MainApplication />} />
                  <Route path="/verify" element={<MyWalletRedirect />} />
                  <Route path="/callback" element={<ZohoCallback />} />
                  <Route path="payment/status" element={<PaymentStatusPage />} />
                </Route>
                <Route path="*" element={<NotFound />} />
              </Routes>
            </BrandingProvider>
          </AdminAuthProvider>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
